import { render, staticRenderFns } from "./AccountInvitations.vue?vue&type=template&id=1f88686a"
import script from "./AccountInvitations.vue?vue&type=script&lang=js"
export * from "./AccountInvitations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports